import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftSalesManagementAutocompleteResponse } from '@/repositories/generated';

const response: GiftSalesManagementAutocompleteResponse[] = [
  {
    id: '1',
    name: 'モック販売管理1',
  },
  {
    id: '2',
    name: 'モック販売管理2',
  },
  {
    id: '3',
    name: 'モック販売管理3',
  },
];

export const autocompleteSalesManagement = http.get(
  createMockEndpoint('/autocomplete/gift_sales_management'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
